import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from '@mui/material';
import LinuxOrMac from '../sections/@dashboard/monitorGraph/linuxOrMac/LinuxOrMac';

export default function LinuxOrMacGraphPage() {
  return (
    <>
      <Helmet>
        <title>MonitorGraph| WatchNod</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <LinuxOrMac />
      </Container>
    </>
  );
}
